// extracted by mini-css-extract-plugin
export default {"main":"Nba-z"};